import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../store/api/rx-factory'
import * as Enpoints from '../../../../store/api/endpoints'
import * as COMMON from '../../../../store/commomFunction'
import moment from 'moment'
export const actions = {
	[Const.RUN_TICKET_RESEND_OTP]({commit, state,getters,dispatch}, credentials){	
  		credentials.localParams.parameter.submitted = false
		  COMMON._executeApi(Enpoints.EP_TICKET_RESEND_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'Email has been send to your registered email address.','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
	[Const.RUN_TICKET_REQUEST_OTP]({commit, state,getters,dispatch}, credentials){	
  		credentials.localParams.parameter.submitted = false
		COMMON._executeApi(Enpoints.EP_TICKET_REQUEST_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				if(credentials.localParams.type && credentials.localParams.type == 'pro'){
					credentials.localParams.parameter.show_step = ''
				}
			}else{
				if(credentials.localParams.type && credentials.localParams.type == 'pro'){
					credentials.localParams.parameter.show_step = ''
				}
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_TICKET_CHECK_OTP]({commit, state,getters,dispatch}, credentials){	
  		let localParam = credentials.localParams
  		/*if(parseInt(localParam.module) == 1  && parseInt(localParam.title) == 88){
  			console.log('localParam.$parent.numberWithCountry',localParam.parameter.$parent.numberWithCountry)
  			let get_user = getters[types.GET_USER]
			get_user.mobile_no = localParam.parameter.$parent.numberWithCountry
			commit(types.SET_STATE , get_user)
			
			var user = localStorage.getItem('user')
			user = atob(user)	;	user = JSON.parse(user)
			user.mobile_no = credentials.localParams.data										
			localStorage.setItem('user', btoa(JSON.stringify(user)))
  		}*/
  		localParam.parameter.submitted = false
		localParam.parameter.$parent.submitted = false
		COMMON._executeApi(Enpoints.EP_TICKET_CHECK_OTP, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(parseInt(localParam.module) == 1 && parseInt(localParam.title) == 87){
					credentials.localParams.parameter.$parent.$parent.$parent.$parent.logout()
					//_messageDisplayFunction(credentials.localParams,'as you have changed your primary email , so please login again','success')
				}else if(parseInt(localParam.module) == 1  && parseInt(localParam.title) == 88){
					let get_user = getters[types.GET_USER]
					get_user.mobile_no = localParam.parameter.$parent.numberWithCountry
					commit(types.SET_STATE , get_user)
					
					var user = localStorage.getItem('user')
					user = atob(user)	;	user = JSON.parse(user)
					user.mobile_no = credentials.localParams.data										
					localStorage.setItem('user', btoa(JSON.stringify(user)))
					localParam.parameter.$parent.congModule = true
				}else if(credentials.localParams.data && credentials.localParams.data == 'pro'){
					credentials.localParams.parameter.$parent.show_step = ''
					localParam.parameter.$parent.congModule = true
				}else if(parseInt(localParam.module) == 16){  //pehle 93 tha 
					if(localParam.ticketRequestFrom == 'deposit'){
						localParam.parameter.$router.replace({ name: "fxView.deposit",params:{account_id_from_ticket:localParam.accountId}}) 
					}else if(localParam.ticketRequestFrom == 'profile'){
						localParam.parameter.$router.replace('/profile') 
						_messageDisplayFunction(credentials.localParams.parameter,'bank add successfully','success')
					}else if(localParam.ticketRequestFrom == 'profileOtp'){
						credentials.localParams.parameter.$parent.trans_id = '' 
						credentials.localParams.parameter.$parent.getUserProfileFunc()
						_messageDisplayFunction(credentials.localParams.parameter,'payment method disable successfully','success')
					}else{
						localParam.parameter.$parent.congModule = true
					}
				}else{
					localParam.parameter.$parent.congModule = true
				}

			}else{
				if(credentials.localParams.data && credentials.localParams.data == 'pro'){
					credentials.localParams.parameter.$parent.show_step = ''
				}
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_GET_TICKET_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_TICKET_LIST, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.parameter.$parent.setView != '' && parseInt(credentials.globalParams.status) == 0){
					let ticket_id = '';
					for(let i=0 ; i<= result.res_data.records.length-1 ; i++){
						if(parseInt(result.res_data.records[i].reason) == 91){
							ticket_id = result.res_data.records[i].id
						}
						// if(i == result.res_data.records.length-1){
						// 	credentials.localParams.parameter.$router.replace({ name: "view",query:{id:ticket_id}})
						// }
					}
				}
				commit(Const.SET_TICKET_LIST, result.res_data)
			}else{
				commit(Const.SET_TICKET_LIST, []) 
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_TICKET_REASON_LIST]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_TICKET_REASON_LIST, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				let ticketData = _ticketFunction(result.res_data)
				commit(Const.SET_TICKET_DATA, ticketData)
				let count = 0
				for(var key in  result.res_data){
					count++
					if(result.res_data[key].categories && result.res_data[key].categories != undefined && result.res_data[key].categories.length >0){
						let categoriesList = {}
						for(let i=0; i<= result.res_data[key].categories.length-1 ; i++){
							
							categoriesList[result.res_data[key].categories[i].id] = result.res_data[key].categories[i]
							if(i == result.res_data[key].categories.length-1){
								delete result.res_data[key].categories
								result.res_data[key]['categories'] = categoriesList
							}
						}
					}
					if(count == Object.keys(result.res_data).length){
						commit(Const.SET_TICKET_REASON_LIST, result.res_data)
					}
				}
				
			}else{
				commit(Const.SET_TICKET_REASON_LIST, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[Const.RUN_GET_TICKET_DETAIL]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_GET_TICKET_DETAIL, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.$parent.ticketUpdate = false
				commit(Const.SET_TICKET_VIEW, result.res_data)
			}else{
				commit(Const.SET_TICKET_VIEW, [])
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[Const.RUN_TICKET_REPLY]({commit, state,getters,dispatch}, credentials){	
		COMMON._executeApi(Enpoints.EP_TICKET_REPLY, credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.clear()
				let user_notify = getters[Const.GET_USER_NOTIFICATIONS]
				let i;
				if(user_notify.length > 0){
					for(i=0 ; i<=user_notify.length-1 ; i++){
						if(user_notify[i].notification_type == 'TICKET' && user_notify[i].ticket_id == credentials.localParams.tick_id){
							let user_info = getters[types.GET_USER]
							user_info.unread_notification = user_info.unread_notification - 1
							commit(types.SET_STATE, user_info)

							var user = localStorage.getItem('user')
							user = atob(user)	;	user = JSON.parse(user)
							user.unread_notification = user.unread_notification - 1					
							localStorage.setItem('user', btoa(JSON.stringify(user)))
						}
					}
				}
				//_messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	}
}

function _ticketFunction(respData){
	// priority basis keys 
	//parent  ['1', '3', '4', '2']
	const getResponseData = respData
	let keyByPriortity = []
	let obj = {}
	let count = 0
	for(var key in  getResponseData){
		const parent_id = getResponseData[key].id
		keyByPriortity[getResponseData[key].priority] = parent_id
		obj["-1"] = keyByPriortity
		
		let childCount = 0
		count++
		const child = getResponseData[key].categories
		//console.log(child)
		if(child){
			let childPriority = []
			for(var i=0; i <= child.length-1; i++){
				const children = child[i]
				childPriority[children.priority] = children.id
				childCount++
				if(i ==  child.length-1){
					//empty
					var filtered = childPriority.filter(function (el) {
					  return el != null && el != '';
					});
					obj[parent_id] = filtered
				}
				if(i== child.length-1 && count == Object.keys(getResponseData).length){
					var childfiltered = keyByPriortity.filter(function (el) {
					  return el != null && el != '';
					});
					obj["-1"]= childfiltered
					return obj
				}
			}
		}else{
			if(count == Object.keys(getResponseData).length){
				var childfiltered = keyByPriortity.filter(function (el) {
				  return el != null && el != '';
				});
				obj["-1"]= childfiltered
				return obj;
			}
		}
		
	}
}
/*
function _executeApi (apiLink, credentials,getToken,commit, callback) {
	try{
		let response_array = []
		if(credentials.localParams.type == 'form'){ credentials.globalParams = credentials.globalParams.form }
		if(getToken == ''){	 getToken = '' }
		credentials.localParams.parameter.pageLoader = true
		
		RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams,getToken)
		.map(response => response.data)
		.subscribe(data => 
		{	
			credentials.localParams.parameter.pageLoader = false
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data
					callback(false, response_array)
				}else{
					if(typeof data.msg == 'object'){
						response_array.res_data = data.msg.code
					}else{
						response_array.res_data = data.msg
					}
					callback(true, response_array)
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){ _handleErrorResponse(ex, commit) }
}
function _messageDisplayFunction(getParameter,getMessage,msgType){
	//getParameter.response_msg = getMessage
	//getParameter.msg_type = msgType
	getParameter.$notify({
		group: 'foo',
		type : msgType,
		text: getMessage,
		duration: 10000,
		closeOnClick : true
	});
}

function _cleanUp (commit, msg, status, loaderId) {
  	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
 	commit("SET_INFO", msg)
}

function _handleErrorResponse (e, commit) {
  	let response = {info: 'NOK', msg: 'Service not available'}
  	if (typeof e.response === 'undefined') {
    	try {
      		const statusCheck = e.toString().toLowerCase()
	      	if (statusCheck.indexOf('network') > -1) {
	        	response = {info: 'NOK', msg: 'Network Error'}
	      	}
    	} catch (e) {}
  	} else {
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}

function _handleLogout (data, commit,options) {
	const router = options.router
	let user = {}
	localStorage.clear();
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace("/")
	}
}*/


// WEBPACK FOOTER //
// ./src/plugins/support/provider/store-addons/actions.js